import React from 'react';
import SEO from '../../components/seo/SEO';
import { getOrganizationSchema, getWebPageSchema } from '../../components/seo/StructuredData';
import Content from '../../components/layout/Section02';
import ServiseAnswer from '../../components/layout/Section03';
import Hero from '../../components/layout/HeroScreen';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import CookieAlert from '../../components/ui/cookie_alert';
import '../../styles/components/nav.css';
import '../../styles/components/header.css';
import SuccessStories from '../../components/layout/Section04';
import Getintouch from '../../components/layout/GetInTouch';
import MakeACall from '../../components/layout/TechTalk';
import InstagramPost from '../../components/ui/InstagramPost';

export default function HomePage() {
  const structuredData = [
    getOrganizationSchema(),
    getWebPageSchema(
      "Algoarts - IT Consulting and Software Development",
      "Have the right digital setup to work smarter, match modern digital customer experience needs and grow revenue with our IT consulting and services.",
      "https://algoarts.tech/"
    )
  ];


  return (
    <div>
      <SEO
        title="Algoarts - IT Consulting and Software Development Services"
        description="Have the right digital setup to work smarter, match modern digital customer experience needs and grow revenue with our IT consulting and services. We provide custom software development, web development, AI/ML solutions, and cloud services."
        keywords="IT consulting, software development, custom software, web development, digital transformation, AI machine learning, cloud solutions, software services, Sri Lanka"
        url="https://algoarts.tech/"
        structuredData={structuredData}
      />
      <Navbar />
      <Hero />
      <Content />
      <ServiseAnswer />
      <SuccessStories />
      <MakeACall />
      <InstagramPost/>
      <Getintouch />
      <Footer />
      <CookieAlert />
    </div>
  )
}



